import { render, staticRenderFns } from "./MainChatBox.vue?vue&type=template&id=33736744&scoped=true&"
import script from "./MainChatBox.vue?vue&type=script&lang=js&"
export * from "./MainChatBox.vue?vue&type=script&lang=js&"
import style0 from "./MainChatBox.vue?vue&type=style&index=0&id=33736744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33736744",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
